import React, { useMemo, useState } from 'react'
import { addDays, format, isSameDay } from 'date-fns'

export default function DatePicker({ dias = 7, onChange }) {
  const [selectedDate, setSelectedDate] = useState(null)

  const daysFull = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']
  const daysShort = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

  function selectDate(date) {
    setSelectedDate(date)
    onChange && onChange(date)
  }

  function selecionarHoje() {
    selectDate(new Date())
  }

  function selecionarAmanha() {
    selectDate(addDays(new Date(), 1))
  }

  const datas = useMemo(() => {
    const hoje = new Date()
    return Array.from({ length: dias }, (_, i) => addDays(hoje, i))
  }, [dias])

  return (
    <div className="
      flex flex-col gap-4 items-center
      p-6 border-2 border-border dark:border-neutral-700 rounded-none shadow-none bg-card dark:bg-neutral-800
      w-full max-w-md
    ">
      {/* Header */}
      <h1 className="font-semibold text-base text-foreground dark:text-neutral-100">
        {selectedDate
          ? daysFull[selectedDate.getDay()]
          : 'Selecione uma data'}
      </h1>

      {/* Calendário inline */}
      <div className="flex flex-wrap justify-between gap-0 w-full">
        {datas.map((data) => {
          const ativo = selectedDate && isSameDay(selectedDate, data)

          return (
            <button
              key={data.toISOString()}
              onClick={() => selectDate(data)}
              className="
                flex flex-col items-center gap-1
                w-[50px] p-2 rounded-none
                hover:bg-muted dark:hover:bg-neutral-700 transition-colors duration-150
              "
            >
              <span className="text-xs font-medium text-muted-foreground dark:text-neutral-400">
                {daysShort[data.getDay()]}
              </span>

              <div
                className={`
                  flex items-center justify-center
                  w-10 h-10 rounded-none text-sm font-bold
                  border-2
                  transition-all duration-150
                  ${ativo
                    ? 'bg-primary text-white border-primary'
                    : 'bg-muted dark:bg-neutral-700 text-foreground dark:text-neutral-100 border-border dark:border-neutral-600'}
                `}
              >
                {data.getDate()}
              </div>
            </button>
          )
        })}
      </div>

      {/* Ações rápidas */}
      <div className="flex flex-col md:flex-row gap-3 w-full ">
        <button
          onClick={selecionarHoje}
          className="
            flex flex-1 items-center justify-center gap-2
            bg-gray-100 border border-gray-300
            px-4 py-2 rounded-xl font-medium
            hover:bg-primary hover:text-white transition
          "
        >
          <span className="material-icons text-base">wb_sunny</span>
          Hoje
        </button>

        <button
          onClick={selecionarAmanha}
          className="
            flex flex-1 items-center justify-center gap-2
            bg-gray-100 border border-gray-300
            px-4 py-2 rounded-xl font-medium
            hover:bg-primary hover:text-white transition
          "
        >
          <span className="material-icons text-base">date_range</span>
          Amanhã
        </button>
      </div>
    </div>
  )
}
